module.exports = __webpack_public_path__ + "img/africana_studies_institue.bc5f35c6.png";